import React, { useEffect, useState } from 'react'
import { supabase } from '../../lib/api'
import { flipDate } from '../../lib/dates'

export function TableObjetos({ language, userId }) {
    const [objetos, setObjetos] = useState([])

    useEffect(() => {
        fetchObjectsByUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchObjectsByUser = async () => {
        let { data, error } = await supabase
            .from('objetos')
            .select('nom_objecte, data_entrada_objecte, num_diposit')
            .eq('id_usuari', userId)
            .not('num_diposit', 'is', null) // num_diposit IS NOT NULL
            .neq('num_diposit', 0) // num_diposit != 0

        if (error) {
            console.log(error)
            return false
        }

        setObjetos(data)
    }

    return (
        <>
            {objetos.length === 0 ? (
                <div className="alert alert-warning" role="alert">
                    {language === 'castellano' ? 'No tienes objetos en depósito' : 'No tens objectes en depòsit.'}
                </div>
            ) : (
                <div className="overflow-x-auto w-full">
                    <table class="table">
                        <thead>
                            <tr>
                                {language === 'castellano' ? (
                                    <>
                                        <th scope="col">Nombre objeto</th>
                                        <th scope="col">Fecha entrada</th>
                                        <th scope="col">Número de deposito</th>
                                    </>
                                ) : (
                                    <>
                                        <th scope="col">Nom objecte</th>
                                        <th scope="col">Data d'entrada</th>
                                        <th scope="col">Número del depòsit</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {objetos?.map(({ nom_objecte, data_entrada_objecte, num_diposit }) => (
                                <tr>
                                    <th scope="row">{nom_objecte}</th>
                                    <td>{flipDate(data_entrada_objecte)}</td>
                                    <td>{num_diposit}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}
